export default {
  Language: 'English',
  system: {
    homePage: {
      login: 'login',
      register: 'register',
    },
    headerMenu: {
      HomePage: "Home Page",
      ScientificData: "Scientific Data",
      PDSDataSet: "PDS DataSet",
      LunarSample: "Planetary Database ",
      WebGis: "WebGis",
      Moon: "Moon",
      Mars: "Mars",
      Planet: "Planet",
      SampleMoon: "Lunar Samples",
      SampleAsteroid: 'Asteroids Samples',
      ResourceTools: "Resource Tools",
      AboutUs: "About Us",
      PopularScience: "Popular Science",
      PlanetaryDatabaseName: "Planetary Database",
      extraterrestrial: "Extraterrestrial Samples",
    },
    infoData: {
      lastNew: "Recent News",
      more: "more",
      Roam: "Moon",
      Lunar: "Lunar",
      MoonandPlanets: "Moon and Planets",
      PopularScience: "Popular Science",
      RecentNews: "Recent News",
      DataRelease: "Data Release",
      TasksIntroduction: "Tasks Introduction",
      OngoingNews: "Ongoing News",
      LatestProduct: "Latest Product",
      NoticeandAnnouncement: "Noticeand Announcement",
      Other: "Other",
      ReleaseTime: "ReleaseTime",
      PageViews: "PageViews"
    },
    footData: {
      Name: "National Astronomical Observatories of China",
      ContactUs: "Contact Us",
      RecordNumber: "Record Number",
      WenbaoNetworkSecurityFilingNumber: "Wenbao Network Security Filing Number"
    },
    PopularScience: {
      Moon: "Moon",
      Mars: "Mars",
      ViewCount: "View Count",
      AllCategories: "All Categories",
      DataIndex: "Data Index",
      Producer: "Producer",
      Description: "Description",
      Time: "Time"
    },
    ResourceTools: {
      ResourceTools: "Resource Tools",
      ScienceProducts: "Science Products",
      ModelProducts: "Model Products",
      Books: "Books",
      NationalStandard: "National Standard"
    },

  },
  regist: {
    UserType: "UserType",
    UserName: "UserName",
    Email: "Email",
    RealName: "RealName",
    Password: "Password",
    ConfirmPassword: "ConfirmPassword",
    VerificationCode: "VerificationCode",
    Company: "Company",
    Telephone: "Telephone",
    Fax: "",
    DetailedAddress: "",
    Postcode: ""
  },
  ScientificData: {
    DataCatalog: "Data Catalog",
    ReturnHomePage: "Return HomePage",
    ScientificDataTree: "Scientific Data Tree",
    MissionIntroduction: "Mission Introduction",
    DataDeclaration: "Data Declaration",
    ReferenceAndAcknowledgement: "Reference And Acknowledgement",
    CopyrightNotice: "Copyright Notice",
    CurrentPosition: "Current Position",
    HomePage: "HomePage",
    ScientificData: "Scientific Data",
    Mars: "Planet",
    Moon: "Moon",
    Tianwen: "Tianwen-1",
    TaskModel: "Task Model",
    DataType: "Data Type",
    PublicData: "Public Data",
    ProtectedData: "Protected Data",
    CarryingPlatform: "Carrying Platform",
    DataAcquisitionTime: "Data AcquisitionTime",
    FirstReleaseTime: "First ReleaseTime",
    LatestReleaseTime: "Latest ReleaseTime",
    DataStatus: "Data Status",
    PublicAccess: "Public Access",
    AuthorizedAccess: "Authorized Access",
    Others: "Others",
    DataServiceContactInformation: "Data Service Contact Information",
    TotalReleaseBatches: "Total Release Batches",
    DataVolume: "Data Volume",
    DataFormat: "Data Format",
    DataVersion: "Data Version",
    DataProducer: "Data Producer",
    DataAceess: {
      Payload: "Payload",
      DataLevel: "Data Level",
      AdvancedSearch: "Advanced Search",
      Longitude: "Longitude",
      Latitude: "Latitude",
      DisplayonPlanetMap: "Display on PlanetMap",
      Reset: "Reset",
      DataName: "Data Name",
      StartTime: "Start Time",
      EndTime: "End Time",
      OrbitNumber: "Orbit Number",
      Search: "Search",
      ClearSearch: "Clear Search",
      DataList: "Data List",
      ReceivingStation: "Receiving Station",
      DetectionMission: "Detection Mission",
      Size: "Size",
      DataVersion: "Data Version",
      BatchDownload: "Batch Download",
      BatchFavorite: "Batch Favorite",
      DownloadNow: "Download Now",
      AddtoFavorites: "Addto Favorites",
      ExpandMore: "Expand More",
      DataAcquisition: "Data Acquisition",
      CancelFavorites: "Cancel Favorites",
      NoDataAvailable: "No Data Available",
      DataStatus: "Data Status"
    }
  },
  DetailMoon: {
    startDate: 'Data Start Date',
    endDate: 'Data End Date',
    genDate: 'Data Generation Date',
    releaseTime: 'Latest Release Time',
    pendingReview: 'Pending Review',
    applyDownload: 'Apply for Download',
    producer: 'Data Producer',
    doi: 'DOI'
  },
  Login: {
    UserName: "UserName",
    PassWord: "PassWord",
    CheckCode: "CheckCode",
    ForgottenPassword: "ForgottenPassword",
    Login: "Login",
    Cancel: "Cancel",
    PleaseLogin: "Please Login",
    NewUserRegistration: "New User Registration",
    ResetPassword: "Reset Password",
    PleaseEnterYourPassword: "Please Enter Your Password",
    Submit: "Submit",
    PleaseEnterUserAccount: "Please enter user account"
  },
  Register: {
    title: 'Register',
    Submit: "Submit",
    userType: 'User Type',
    userTypeSci: 'Scientific Data User',
    userTypeSample: 'Sample User',
    accountLabel: 'User Account',
    accountPlaceholder: 'Your account name for login',
    nameLabel: 'Real Name',
    namePlaceholder: 'Your real name',
    phoneLabel: 'Mobile Number',
    phonePlaceholder: 'Please enter mobile number',
    emailLabel: 'Email',
    emailPlaceholder: 'Please enter email',
    companyLabel: 'Organization',
    companyPlaceholder: 'Please enter full organization name',
    idCardLabel: 'ID Number',
    pwdLabel: 'Set Password',
    pwdConfirmLabel: 'Confirm Password',
    pwdConfirmTip: 'Password 6-16 characters, case sensitive',
    codeLabel: 'Verification Code',
    codePlaceholder: 'Enter verification code',
    goLogin: 'Login with existing account'
  },
  FileData: {
    ScientificData: "Scientific Data",
    Mars: "Planet",
    FileName: "FileName",
    FileSize: "FileSize",
    Action: "Action",
    ViewDetail: "ViewDetail",
    Download: "Download"
  },
  PDS: {
    CurrentPosition: "Current Position:",
    HomePage: "Home Page",
    PDSDataSet: "PDS DataSet",
    Moon: "Moon",
    Payload: "Payload",
    DataLevel: "Data Level",
    CollectionStartTime: "Collection Start Time:",
    CollectionEndTime: "Collection End Time:",
    Search: "Search",
    VolumeDataStartTime: "Volume Data Start Time:",
    VolumeDataEndTime: "Volume Data End Time:",
    DetectionTask: "Detection Task:",
    DataSize: "Data Size:",
    FileTotal: "Total Files:",
    DownloadNow: "Download Now"
  },
  MoonSample: {
    PleaseSelectData: "Please select data!",
    OrderCreatedSuccess: "Order created successfully!",
    Total: "Total",
    Records: "records",
    WebsiteHomePage: "Website Home",
    MoonSampleHome: "Moon Sample Home",
    MoonSampleSearch: "Moon Sample Search",
    SampleInfoDescription: "Sample Information",
    BorrowingAndReturn: "Borrowing & Return",
    AboutUs: "About Us",
    MoonSampleInformationDatabase: "Lunar Sample Information Database",
    LunarSampleInformationDatabase: "LUNAR SAMPLE INFORMATION DATABASE",
    MoonSampleInformationAnnouncement: "Moon Sample Information Bulletin",
    More: "More",
    LatestNews: "Latest News",
    SampleNumberRules: "Sample Numbering Rules",
    AvailableSampleSearch: "Available Sample Search",
    MySamples: "My Samples",
    ReapplyRejected: "Re-submit Rejected Application",
    SampleType: "Sample Type",
    SampleFeature: "Sample Feature",
    CanApply: "Available",
    Borrowing: "Borrowing",
    BorrowingReview: "Under Review",
    ReturnMonitoring: "Return Monitoring",
    Operation: "Operation",
    Details: "Details",
    NoData: "No Data",
    TotalRecords: "Total {count} records",
    DetectTaskInfo: "Detection Mission Info",
    DetectTask: "Detection Mission",
    Location: "Location",
    Longitude: "Longitude",
    Latitude: "Latitude",
    SampleBasicInfo: "Sample Basic Info",
    SampleCode: "Sample Code",
    SampleBorrowingInfo: "Sample Borrowing Info",
    UseUnit: "Organization",
    ResponsiblePerson: "Responsible Person",
    UseStatus: "Use Status",
    IssuedWeight: "Issued Weight(mg)",
    ReturnWeight: "Return Weight(mg)",
    Status: "Status",
    DistributionReview: "Distribution Review",
    PendingDistribution: "Pending Distribution",
    BorrowRejected: "Borrow Rejected",
    ReturnDetection: "Return Detection",
    DetectionPassed: "Detection Passed",
    DetectionFailed: "Detection Failed",
    PhotoSampleInfo: "Photo Sample Info",
    ExhibitionEducation: "Exhibition & Education",
    Gift: "Gift",
    Other: "Other",
    ReturnDetectionResult: "Return Detection Result",
    BatchBorrow: "Batch Borrow",
    SearchResults: "Search Results: {total} records",
    Submit: "Submit",
    MoonSampleBorrowApplication: "Moon Sample Borrow Application",
    PleaseLogin: "Please login!",
    PageHeaderBack: "Back",
    PageHeaderContent: "Details",
    Unavailable: "Unavailable",
    PendingSampling: "Pending Sampling",
    PleaseSelect: "Please Select",
    Quantity: "Qty",
    Weight: "Weight(mg)",
    ParticleSize: "Particle Size(mm)",
    SamplePhoto: "Photo",
    SampleClassificationInfo: "Sample Classification",
    SampleDescriptionInfo: "Sample Description",
    SampleClassification: "Sample Classification",
    Level1Category: "Level 1 Category",
    Level2Category: "Level 2 Category",
    Level3Category: "Level 3 Category",
    Level4Category: "Level 4 Category",
    PrimaryCategory: "Primary Category",
    SecondaryCategory: "Secondary Category",
    TertiaryCategory: "Tertiary Category",
    QuaternaryCategory: "Quaternary Category",
    Color: "Color",
    Structure: "Structure",
    MineralComposition: "Mineral Composition",
    SampleDescription: "Description",
    SampleQuantity: "Quantity",
    UseMethod: "Usage",
    UsageMethod: "Usage Method",
    OriginalUse: "Original Use",
    AsIsUsage: "Original Use",
    ConsumptiveUse: "Consumptive Use",
    ConsumptiveUsage: "Consumptive Use",
    DestructiveUse: "Destructive Use",
    DestructiveUsage: "Destructive Use",
    Returned: "Returned",
    NoDescription: "No description",
    SampleDescriptionText: "Description",
    UsingDepartment: "Organization",
    ReturnTesting: "Return Testing",
    TestPassed: "Test Passed",
    TestFailed: "Test Failed",
    ReturnTestResult: "Return Test Result",
    ImageSampleInfo: "Image Sample Info",
    ContactInformation: "Contact Information",
    Email: "Email",
    MySamplesDataDisplay: "My Samples Data Display",
    UseTime: "Use Time",
    PleaseSelectStartUseTime: "Please select start time",
    PleaseSelectActualReturnTime: "Please select return time",
    Confirm: "Confirm",
    BorrowWeight: "Borrow Weight(mg)",
    ExpectedConsumption: "Expected Consumption(mg)",
    UseResponsiblePerson: "Responsible Person",
    StartUseTime: "Start Use Time",
    EndUseTime: "End Use Time",
    ReviewRejected: "Review Rejected",
    Completed: "Completed",
    Return: "Return",
    ApplyChange: "Apply Change",
    ReturnApplication: "Return Application",
    PleaseInputSampleCode: "Please enter sample code",
    PleaseInputBorrowWeight: "Please enter borrow weight",
    PleaseSelectExpectedReturnTime: "Please select expected return time",
    PleaseInputExpectedConsumption: "Please enter expected consumption",
    ActualConsumption: "Actual Consumption(mg)",
    PleaseInputActualConsumption: "Please enter actual consumption",
    PleaseInputReturnWeight: "Please enter return weight",
    PleaseUploadReturnMaterials: "Please upload return materials below",
    SampleUsageReport: "Sample Usage Report",
    ClickUpload: "Click to Upload",
    SampleTestAnalysisData: "Sample Test & Analysis Data",
    SampleUsageRecord: "Sample Usage Record",
    Remark: "Remark",
    PleaseInputRemark: "Please enter remark",
    OrderInformation: "Order Information",
    SampleId: "Sample ID",
    OrderNumber: "Order Number",
    LegalPerson: "Legal Person",
    LegalPersonId: "Legal Person ID",
    LegalPersonPhone: "Legal Person Phone",
    LegalPersonEmail: "Legal Person Email",
    ResponsiblePersonId: "Responsible Person ID",
    ResponsiblePersonPhone: "Responsible Person Phone",
    ResponsiblePersonEmail: "Responsible Person Email",
    ExpectedReturnTime: "Expected Return Time",
    ActualReturnTime: "Actual Return Time",
    BorrowReviewer: "Borrow Reviewer",
    BorrowReviewTime: "Borrow Review Time",
    ReturnReviewer: "Return Reviewer",
    ReturnReviewTime: "Return Review Time",
    ChangeApplication: "Change Application",
    ExpectedChangeConsumption: "Expected Change Consumption(mg)",
    ExpectedChangeReturnDate: "Expected Change Return Date",
    PleaseSelectDate: "Select Date",
    ChangeApplicationForm: "Change Application Form",
    Education: "Education",
    PopularScience: "Popular Science",
    ResubmitApplication: "Resubmit Application",
    Resubmit: "Resubmit",
    InternalBorrowing: "Internal Borrowing",
    ExternalBorrowing: "External Borrowing",
    ReturnReviewReason: "Return Review Reason",
    Cancel: "Cancel"
  }
};
